import React from 'react';
export function ArrowIcon(props: SVGProps<SVGSVGElement>) {
  return;
}